var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import { defaultItemProps } from './defaults';
import { SpanTag, AnchorTag } from '../../Utils/AtomicTag';
var BreadcrumbItem = /** @class */ (function (_super) {
    __extends(BreadcrumbItem, _super);
    function BreadcrumbItem(props) {
        return _super.call(this, props) || this;
    }
    BreadcrumbItem.prototype.renderCrumbItem = function () {
        var _a = this.props, href = _a.href, children = _a.children, rest = __rest(_a, ["href", "children"]);
        var itemCls = ['text-gray-600', 'text-sm'];
        if (href) {
            itemCls.push('hover:text-brand-600', 'cursor-pointer');
        }
        return href ? (React.createElement(AnchorTag, __assign({ atomics: itemCls, href: href }, rest), children)) : (React.createElement(SpanTag, __assign({ atomics: itemCls }, rest), children));
    };
    BreadcrumbItem.prototype.render = function () {
        var separator = this.props.separator;
        var separatorCls = ['text-gray-600', 'text-sm', 'mx-1'];
        return (React.createElement(React.Fragment, null,
            this.renderCrumbItem(),
            separator && (React.createElement(SpanTag, { atomics: separatorCls, className: "legao-breadcrumb-separator" }, separator))));
    };
    BreadcrumbItem.defaultRowProps = defaultItemProps;
    return BreadcrumbItem;
}(PureComponent));
export { BreadcrumbItem };
